import React from 'react';
import d3 from 'd3';

export default (props) => {
    const lineFunction = 
    d3.svg.line()
    .x(function(d) { return props.xScale(d[0]); })
    .y(function(d) { return props.yScale(d[1]); })
    .interpolate("linear");   
    return <path d={lineFunction(props.dataseries.series)} 
        style={{
            stroke:props.dataseries.color,    
            fill:"none",
            strokeWidth:"2px"
        }}/>
}


// WEBPACK FOOTER //
// ./src/js/components/charting/ChartLine/ChartLine.jsx